import { set } from 'es-toolkit/compat';
import * as yup from 'yup';
import { z } from 'zod';
import { YUP_OLD_EMAIL_REGEX } from '@clearverify/constants';
export const emailValidationSchema = yup
    .string()
    .matches(YUP_OLD_EMAIL_REGEX, 'Format is incorrect');
export const validateWithSchema = async (schema, values, validationOptions) => {
    try {
        await schema.validate(values, {
            abortEarly: false,
            ...validationOptions,
        });
        return {};
    }
    catch (error) {
        return validationYupErrorHandler(error);
    }
};
export const validateSyncWithSchema = (schema, values, validationOptions) => {
    try {
        schema.validateSync(values, {
            abortEarly: false,
            ...validationOptions,
        });
        return {};
    }
    catch (error) {
        return validationYupErrorHandler(error);
    }
};
const validationYupErrorHandler = (error) => {
    if (error instanceof yup.ValidationError) {
        return error.inner.reduce((acc, error) => {
            return set(acc, String(error.path), error.errors[0]);
        }, {});
    }
    return {};
};
export const validationZodErrorHandler = (error) => {
    return error.issues.reduce((acc, issue) => {
        return set(acc, issue.path, issue.message);
    }, {});
};
export const isZodError = (error) => {
    return error instanceof z.ZodError;
};
//# sourceMappingURL=validation.js.map